import React from 'react'
import FirstLoadController from '../../components/FirstLoadController'
import Shipping from './Shipping'

export default function (props: Props) {
  return (
    <FirstLoadController active={props.active}>
      <Shipping {...props} />
    </FirstLoadController>
  )
}
